import * as types from './mutation-types'

export default {
  [types.SAVE_SESSION] (state, payload) {
    state.user_mail = payload.email
    state.user_firstname = payload.firstname
    state.user_lastname = payload.name
    try {
      localStorage.setItem('session', JSON.stringify({
        user_mail: state.user_mail,
        user_firstname: state.user_firstname,
        user_lastname: state.user_lastname,
        user_phone: state.user_phone
      }))
    } catch (e) {
      console.log('no localStorage')
    }
  },
  [types.UPDATE_PHONE] (state, payload) {
    state.user_phone = payload.phone
    try {
      localStorage.setItem('session', JSON.stringify({
        user_mail: state.user_mail,
        user_firstname: state.user_firstname,
        user_lastname: state.user_lastname,
        user_phone: state.user_phone
      }))
    } catch (e) {
      console.log('no localStorage')
    }
  }
}
